/**
 * ADR-0182 conductor ruling 2026-09-03 — changeover symbols get the board's
 * own hover-card treatment, not native title tooltips. One card serves both
 * faces: the gap fill in a lane and the class chip on the Next-Up rail.
 * Content comes from changeoverCard() in laneMath.ts (unit-locked there).
 */
import type { BoardLaneJob } from "../../boardTypes.js";
import { changeoverCard, type HoverPlacement } from "./laneMath.js";

export function ChangeoverHoverCard(props: {
  job: Pick<BoardLaneJob, "job" | "part" | "setup_class" | "setup_hours" | "setup_cost_fallback">;
  /** class label → measured changeover count (Addendum 5's sample-size line). */
  measuredCounts?: Map<string, number | null>;
  /** Where the card sits, already flipped away from the container's edges. */
  place: HoverPlacement;
}) {
  const card = changeoverCard(props.job, props.measuredCounts);
  return (
    <div className="boardHoverCard" style={props.place}>
      <div className="boardHoverWide">
        <strong>{card.transition}</strong>
      </div>
      {card.rows.map((r) => (
        <div className="boardHoverRow" key={r.label}>
          <strong>{r.label}</strong>
          <span className={r.muted ? "muted" : undefined}>{r.value}</span>
        </div>
      ))}
    </div>
  );
}
